import _isEmpty from 'lodash/isEmpty';
import _keys from 'lodash/keys';
import _pickBy from 'lodash/pickBy';
import _clone from 'lodash/clone';
import searchURL from './urlWriters/searchURL';
import _includes from 'lodash/includes';

export const createSearchURL = (filterParams, saveSessionUrl = true) => {
  // Validation Checking
  let returnURL = '';
  if (!_isEmpty(filterParams.address)) {
    let filters = _clone(filterParams.address);

    if (!filters.streetNumber) {
      delete filters.streetNumber;
    }
    delete filters.formattedAddress;
    delete filters.pretty;
    delete filters.propertyId;
    delete filters.streetSuffix;
    delete filters.surroundSuburbs;

    filters['bathsMin'] = filterParams.bathroom.min;
    filters['bathsMax'] = filterParams.bathroom.max;
    filters['bedsMin'] = filterParams.bedroom.min;
    filters['bedsMax'] = filterParams.bedroom.max;
    filters['carSpacesMin'] = filterParams.carPark.min;
    filters['carSpacesMax'] = filterParams.carPark.max;
    filters['priceMin'] = filterParams.price.min;
    filters['priceMax'] = filterParams.price.max;
    filters['rentedHistory'] = filterParams.rentedHistory;
    filters['soldHistory'] = filterParams.soldHistory;
    filters['sort'] = filterParams.sort;
    if (filterParams.propertyStatus.length === 0 || filterParams.propertyStatus.length === 4) {
      filters['status'] = ['off-market', 'for-sale', 'for-rent', 'sold'];
    }
    else {
      let stats = _keys(_pickBy((filterParams.propertyStatus)));
      if (!stats.length) stats = ['off-market', 'for-sale', 'for-rent', 'sold'];
      filters['status'] = stats;
    }
    if (filterParams.propertyType === 0 ||  filterParams.propertyType === 6) {
      filters['types'] = [];
    }
    else {
      filters['types'] = _keys(_pickBy((filterParams.propertyType)));
    }

    if(!_includes(filters.status, 'off-market') || !_includes(filters.status, 'sold')) {
      const {additionalFeaturesQuery} = filterParams;
      Object.keys(additionalFeaturesQuery).forEach((key) => {
        if (key === 'featureFreeText' && !_isEmpty(additionalFeaturesQuery['featureFreeText'])) {
          filters['featureFreeText'] = [...additionalFeaturesQuery['featureFreeText']];
        } else if (additionalFeaturesQuery[key] === true) {
          filters[key] = 'true';
        }
      });
    }

    if(filterParams.excludeUnderOffer) {
      filters['excludeUnderOffer'] = 'true';
    }

    if(filterParams.includeSurroundSuburbs) {
      filters['includeSurroundSuburbs'] = 'true';
    }

    if(filters.status.length === 1 && _includes(filters.status, 'sold')) {
      filters['soldDateStart'] = filterParams.soldDateStart;
    }

    if(filterParams.dateAvailableFrom && typeof filterParams.dateAvailableFrom !== 'string') {
      filters['dateAvailableFrom'] = filterParams.dateAvailableFrom.format('YYYY-MM-DD');
    }

    const saleType = filterParams.saleTypes;
    if(filters.status.length === 1 && _includes(filters.status, 'for-sale')) {
      Object.keys(saleType).forEach((key) => {
        if (saleType[key]) {
          filters[key] = 'true';
        }
      });
    }

    let merged = _pickBy(filters, (value) => value != null);

    returnURL = encodeURI(searchURL(merged));

  }
  if (typeof sessionStorage != 'undefined' && saveSessionUrl) {
    sessionStorage.setItem('lastSearchURL', returnURL);
  } // we're saving this url to use in the breadcrumbs
  return returnURL;
};
